<template>
    <b-card no-body>
        <b-card-header class="border-0 p-3">
                <b-row align-h="between">
                    <b-col cols="auto">
                        <h3 class="mb-0">Transaction History</h3>
                    </b-col>
                    <b-col cols="auto">
                        <el-button class="float-right py-0 text-primary" type="text">View All</el-button>
                    </b-col>
                </b-row>
            </b-card-header>
            <div class="card-table-simple">
                <b-table-simple responsive class="mb-0">
                    <b-thead style="background-color: #A4B0C0;">
                        <b-tr>
                            <b-th>Fund</b-th>
                            <b-th>Amount (RM)</b-th>
                            <b-th>Date</b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="(data, index) in tableData" :key="index">
                            <b-td>{{ data.fund }}</b-td>
                            <b-td>{{ data.fund_amt | moneyFormatter }}</b-td>
                            <b-td>{{ data.fund_date }}</b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </div>
    </b-card>
</template>
<script>
import { Button } from 'element-ui'

export default {
    components: {
        [Button.name]: Button,
    },
    data() {
        return {
            tableData: [
                {
                    fund: 'JV 1.0-15%',
                    fund_amt: 4800,
                    fund_date: '27 Jul 2024'
                },
                {
                    fund: 'Raya 15%',
                    fund_amt: 2400,
                    fund_date: '28 Jun 2024'
                },
            ]
        }
    }    
}
</script>